<script lang="ts" setup>
import cam from "@/assets/image/services/videoSurveillance/nest_cam_iq_outdoor.svg";
import door from "@/assets/image/services/videoSurveillance/door_sensor.svg";
import flyover from "@/assets/image/services/videoSurveillance/flyover.svg";
import house from "@/assets/image/services/videoSurveillance/house_with_shield.svg";
import { $t } from "@/i18n";
import img1 from "@/assets/image/services/electricalInstallations/carousel-elektro-daljinski-pristup.png";
import img2 from "@/assets/image/services/electricalInstallations/carousel-elektro-grejanje.jpg";
import img3 from "@/assets/image/services/electricalInstallations/carousel-elektro-kontrola-potrosnje.png";
import img4 from "@/assets/image/services/electricalInstallations/carousel-elektro-rasveta.png";
import img5 from "@/assets/image/services/electricalInstallations/carousel-elektro-roletne.png";
import { useDefaultStore } from "@/store";
import { $te } from "@/assets/ts/helpers";

const info = computed(() => [
  {
    icon: cam,
    title: $t("app.videoSurveillance.info.1.title"),
    text: $t("app.videoSurveillance.info.1.text"),
    active: true,
  },
  {
    icon: door,
    title: $t("app.videoSurveillance.info.2.title"),
    text: $t("app.videoSurveillance.info.2.text"),
    active: false,
  },
  {
    icon: house,
    title: $t("app.videoSurveillance.info.3.title"),
    text: $t("app.videoSurveillance.info.3.text"),
    active: false,
  },
  {
    icon: flyover,
    title: $t("app.videoSurveillance.info.4.title"),
    text: $t("app.videoSurveillance.info.4.text"),
    active: false,
  },
]);
const store = useDefaultStore();
const carousel = computed(() => [
  {
    image: img1,
    text: $t("app.videoSurveillance.carousel.1"),
    active: true,
  },
  {
    image: img2,
    text: $t("app.videoSurveillance.carousel.2"),
    active: false,
  },
  {
    image: img3,
    text: $t("app.videoSurveillance.carousel.3"),
    active: false,
  },
  {
    image: img4,
    text: $t("app.videoSurveillance.carousel.4"),
    active: false,
  },
  {
    image: img5,
    text: $t("app.videoSurveillance.carousel.5"),
    active: false,
  },
]);

useHead({
  title: `${$te("app.videoSurveillance.heading")} | ${store.SITE_NAME}`,
  meta: [
    {
      name: "title",
      content: `${$te("app.videoSurveillance.heading")} | ${store.SITE_NAME}`,
    },
    {
      name: "description",
      content: $te("app.videoSurveillance.paragraph1"),
    },
    { name: "robots", content: "index, follow" },
    {
      property: "og:title",
      content: `${$te("app.videoSurveillance.heading")} | ${store.SITE_NAME}`,
    },
    {
      property: "og:description",
      content: $te("app.videoSurveillance.paragraph1"),
    },
    { property: "og:site_name", content: store.SITE_NAME },
  ],
});
</script>

<template>
  <m-page class="bg-text-dark">
    <div class="mx-auto max-w-screen-xl">
      <services-page-heading :heading="$t('app.videoSurveillance.heading')"></services-page-heading>
      <services-paragraph class="mb-8 max-w-[779px]" :text="$t('app.videoSurveillance.paragraph1')"></services-paragraph>
      <base-button :text="$t('app.base.contactUs')" route-name="ContactPage" class="mb-12 md:mb-22" bg-color="text-light"></base-button>
      <div class="mb-8 grid gap-6 md:mb-22 md:grid-cols-2">
        <services-info-card v-for="(i, index) in info" :key="index" :icon="i.icon" :title="i.title" :text="i.text"></services-info-card>
      </div>
      <carousel-comp v-if="!store.isWiderThan1307" :carousel="carousel">
        <template #default="{ item, active }">
          <services-image-card :text="item.text ?? ''" :image="item.image" :active="active"></services-image-card>
        </template>
      </carousel-comp>
      <template v-else> <services-wide-carousel :carousel="carousel"></services-wide-carousel> </template>
      <services-paragraph :text="$t('app.videoSurveillance.paragraph2')" class="mt-8"></services-paragraph>
    </div>
  </m-page>
</template>
